import { thFaqs } from '../../content/faqs';
export default function Faq() {
 return <section id="faq" className="studio-faq"><div className="studio-shell faq-layout"><div><p className="studio-eyebrow">คำตอบที่เป็นประโยชน์</p><h2>คำถามเกี่ยวกับ<br />การทำงานร่วมกัน</h2></div><div className="faq-list">{thFaqs.map(([question, answer]) => <details key={question}><summary>{question}<span aria-hidden="true">+</span></summary><p>{answer}</p></details>)}</div></div></section>;
}
